var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg666(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "666 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect139",
    d: "M77.8337 18.5284H21.8487V74.5123H77.8337V18.5284Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect141",
    d: "M157.677 18.5284H101.693V74.5134H157.677V18.5284Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect143",
    d: "M77.8337 99.8711H21.8487V155.854H77.8337V99.8711Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect145",
    d: "M157.677 99.87H101.693V155.854H157.677V99.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect147",
    d: "M238.431 18.773H182.448V74.758H238.431V18.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect149",
    d: "M318.274 18.773H262.287V74.758H318.274V18.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect151",
    d: "M238.431 100.116H182.448V156.098H238.431V100.116Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect153",
    d: "M318.274 100.116H262.287V156.1H318.274V100.116Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect155",
    d: "M77.8337 181.456H21.8487V237.442H77.8337V181.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect157",
    d: "M157.677 181.456H101.693V237.442H157.677V181.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect159",
    d: "M77.8337 262.799H21.8487V318.783H77.8337V262.799Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect161",
    d: "M157.677 262.801H101.693V318.784H157.677V262.801Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect163",
    d: "M238.431 181.456H182.448V237.441H238.431V181.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect165",
    d: "M318.274 181.455H262.287V237.442H318.274V181.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect167",
    d: "M238.431 262.798H182.448V318.783H238.431V262.798Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect169",
    d: "M318.274 262.8H262.287V318.783H318.274V262.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect171",
    d: "M397.461 18.7742H341.476V74.7592H397.461V18.7742Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect173",
    d: "M397.461 100.117H341.476V156.101H397.461V100.117Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect175",
    d: "M397.461 181.456H341.476V237.442H397.461V181.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect177",
    d: "M397.461 262.801H341.476V318.784H397.461V262.801Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect179",
    d: "M77.963 344.143H21.9792V400.127H77.963V344.143Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect181",
    d: "M157.805 344.143H101.822V400.127H157.805V344.143Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect183",
    d: "M238.561 344.143H182.577V400.127H238.561V344.143Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect185",
    d: "M318.404 344.142H262.416V400.125H318.404V344.142Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect187",
    d: "M397.591 344.143H341.604V400.127H397.591V344.143Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect189",
    d: "M477.433 18.773H421.445V74.7569H477.433V18.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect191",
    d: "M478.151 100.115H422.164V156.098H478.151V100.115Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect193",
    d: "M478.151 181.456H422.164V237.442H478.151V181.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect195",
    d: "M478.151 262.799H422.164V318.782H478.151V262.799Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect197",
    d: "M477.562 344.14H421.575V400.124H477.562V344.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect199",
    d: "M78.5524 425.488H22.5685V481.472H78.5524V425.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect201",
    d: "M158.396 425.49H102.411V481.472H158.396V425.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect203",
    d: "M238.496 425.488H182.512V481.472H238.496V425.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect205",
    d: "M318.339 425.49H262.352V481.472H318.339V425.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect207",
    d: "M398.18 425.49H342.195V481.472H398.18V425.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect209",
    d: "M478.151 425.488H422.164V481.472H478.151V425.488Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg666);
export default __webpack_public_path__ + "static/media/666.23afb5fdc6bb33731ca2e1161fef9040.svg";
export { ForwardRef as ReactComponent };